import * as Yup from 'yup';

export const inspectionFeeSchema = Yup.object({
    name: Yup.string()
        .trim()
        .required('Name is required')
        .max(50, 'Max length is 50 characters'),
    type: Yup.string()
        .trim()
        .required('Type is required'),
    price: Yup.string()
        .trim()
        .required('Price is required'),
    fee: Yup.string()
        .trim()
});
